import StepBuy_1 from "../step_1";
import StepBuy_2 from "../step_2";

const getBaseSteps = () => {
  // начало визарда
  return [<StepBuy_1 />, <StepBuy_2 />];
};
export default getBaseSteps;
